import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

interface CTASectionProps {
  className?: string;
}

const CTASection = ({ className = '' }: CTASectionProps) => {
  return (
    <section className={`bg-gradient-to-br from-primary to-secondary py-16 lg:py-24 ${className}`}>
      <div className="mx-auto max-w-7xl px-4 lg:px-6">
        <div className="text-center">
          <h2 className="mb-4 font-heading text-3xl font-bold text-primary-foreground lg:text-4xl">
            Готовы начать оптовые закупки?
          </h2>
          <p className="mx-auto mb-8 max-w-2xl text-lg text-white lg:text-xl">
            Оформите заявку прямо сейчас и получите персональную консультацию от нашего менеджера в течение 30 минут
          </p>
          
          <div className="flex flex-col items-center justify-center gap-4 sm:flex-row">
            <Link
              href="/product-catalog"
              className="inline-flex items-center justify-center gap-2 rounded-md bg-accent px-8 py-4 font-heading text-base font-medium text-accent-foreground shadow-lg transition-all duration-250 hover:-translate-y-0.5 hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-accent-foreground focus:ring-offset-2 active:scale-[0.97]"
            >
              <Icon name="ShoppingBagIcon" size={20} />
              <span>Перейти в каталог</span>
            </Link>
            
            <Link
              href="/shopping-cart"
              className="inline-flex items-center justify-center gap-2 rounded-md border-2 border-primary-foreground/30 bg-primary-foreground/10 px-8 py-4 font-heading text-base font-medium text-primary-foreground backdrop-blur-sm transition-all duration-250 hover:-translate-y-0.5 hover:bg-primary-foreground/20 focus:outline-none focus:ring-2 focus:ring-primary-foreground focus:ring-offset-2 active:scale-[0.97]"
            >
              <Icon name="ClipboardDocumentListIcon" size={20} />
              <span>Оформить заявку</span>
            </Link>
          </div>
          
          <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-3">
            <div className="rounded-md bg-primary-foreground/10 p-6 backdrop-blur-sm">
              <div className="mb-2 flex items-center justify-center">
                <Icon name="PhoneIcon" size={32} className="text-accent" />
              </div>
              <h3 className="mb-2 font-heading text-lg font-semibold text-primary-foreground">
                Телефон
              </h3>
              <p className="font-caption text-sm text-white">
                +7 702 446 8477
              </p>
            </div>
            
            <div className="rounded-md bg-primary-foreground/10 p-6 backdrop-blur-sm">
              <div className="mb-2 flex items-center justify-center">
                <Icon name="ChatBubbleLeftRightIcon" size={32} className="text-accent" />
              </div>
              <h3 className="mb-2 font-heading text-lg font-semibold text-primary-foreground">
                Telegram
              </h3>
              <a
                href="https://t.me/optovichokalmaty"
                target="_blank"
                rel="noopener noreferrer"
                className="font-caption text-sm text-white underline decoration-white/60 underline-offset-4 transition-colors duration-250 hover:text-white/90"
              >
                t.me/optovichokalmaty
              </a>
            </div>
            
            <div className="rounded-md bg-primary-foreground/10 p-6 backdrop-blur-sm">
              <div className="mb-2 flex items-center justify-center">
                <Icon name="ClockIcon" size={32} className="text-accent" />
              </div>
              <h3 className="mb-2 font-heading text-lg font-semibold text-primary-foreground">
                Режим работы
              </h3>
              <p className="font-caption text-sm text-white">
                8:00-17:00, вт-вс (пн: выходной)
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;